import React, { useState } from "react";
import classNames from "classnames/bind";

import styles from "./Profile.module.scss";
const cx = classNames.bind(styles);

const ProfileIcon = ({ user }) => {
  const [isError, setIsError] = useState(false);

  const getChar = () => {
    if (user.userName !== "") return user.userName.charAt(0);

    return user.emailId.charAt(0);
  };

  return (
    <div className={cx("profile-icon-root", { placeholder: isError })}>
      {!isError ? (
        <img
          src={user.userImagePath}
          alt="user profile"
          onError={() => setIsError(true)}
        />
      ) : (
        <span>{getChar()}</span>
      )}
    </div>
  );
};

export default ProfileIcon;
